export default __webpack_public_path__ + "static/media/fairy.767c2f56.svg";